
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_brdst_1ogv3_9",
  "loading": "awsui_loading_brdst_1ogv3_13",
  "undo-button": "awsui_undo-button_brdst_1ogv3_17"
};
  